import {
  resource,
} from 'common/store/selectors';

const getScope = ({ job: { job } }) => job;

const {
  isLoading,
  getResourceContext,
  getResourceMaybe,
} = resource.factory(getScope);

export {
  isLoading,
  getResourceContext as getJobContext,
  getResourceMaybe as getJobMaybe,
};
